var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingtime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.194,
    height: 49.194,
    viewBox: "0 0 49.194 49.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_17616978291577437017",
    "data-name": 17616978291577436000,
    d: "M26.6,2a24.6,24.6,0,1,0,24.6,24.6A24.669,24.669,0,0,0,26.6,2ZM38.9,28.354H26.6A1.66,1.66,0,0,1,24.84,26.6V10.785a1.757,1.757,0,1,1,3.514,0V24.84H38.9a1.757,1.757,0,1,1,0,3.514Z",
    transform: "translate(-2 -2)",
    fill: "#17b3f0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingtime);
export default __webpack_public_path__ + "static/media/bookingtime.b84f974ca3befc64c884d4ddc30acc87.svg";
export { ForwardRef as ReactComponent };